var map = {
	"./default/logo_navbar.png": [
		78718,
		78718
	],
	"./documentation/logo_navbar.png": [
		77164,
		77164
	],
	"./epista/logo_navbar.png": [
		5500,
		5500
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 4466;
module.exports = webpackAsyncContext;